import { Card, Col, Row } from 'antd';
import React, { FC } from 'react';
import { currencyFormatter } from '../../utils/DataFormatterUtils';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import FileUploader from '../file_uploader/FileUploader';
import PMTemplateTasksDisplay from './PMTemplateTasksDisplay';
import { connect } from 'react-redux';

const PMTemplateDetailCard: FC<any> = ({
	plannedMaintenanceTemplate,
	showTitle,
	userType,
}): React.ReactElement => {
	return (
		<Row style={{ margin: '16px 4px' }} gutter={12}>
			<Col span={24}>
				<div className="rowSpacing">
					<Card
						bodyStyle={{ padding: 0 }}
						title={showTitle ? plannedMaintenanceTemplate.title : ''}
					>
						<div className="materialCard__body">
							{plannedMaintenanceTemplate.templateId ? (
								<div className="materialCard__subtitle">
									<div style={{ fontSize: 16, marginBottom: 24 }}>
										Template ID: {plannedMaintenanceTemplate.templateId}
									</div>
								</div>
							) : null}
							<div className="materialCard__primaryTitle">
								<div
									style={{ fontSize: 16 }}
									className="richTextWrapper"
									dangerouslySetInnerHTML={{ __html: plannedMaintenanceTemplate.description }}
								/>
							</div>
							{plannedMaintenanceTemplate.nte ? (
								<div className="materialCard__subtitle">
									<div style={{ fontSize: 16, marginBottom: 24 }}>
										NTE: {currencyFormatter(2)(plannedMaintenanceTemplate.nte)}
									</div>
								</div>
							) : null}
							{plannedMaintenanceTemplate.supplierFacilityId ? (
								<div className="materialCard__subtitle">
									<div style={{ fontSize: 16, marginBottom: 24 }}>
										Assign To: {plannedMaintenanceTemplate.supplierFacility.name}
									</div>
								</div>
							) : null}
							{plannedMaintenanceTemplate.supplierContractId ? (
								<div className="materialCard__subtitle">
									<div style={{ fontSize: 16, marginBottom: 24 }}>
										Contract ID: {plannedMaintenanceTemplate.supplierContractId}
									</div>
								</div>
							) : null}
						</div>
					</Card>
					{nullSafeGet('attachments.0', plannedMaintenanceTemplate) ? (
						<div className="mt-2">
							<Card title="Attachments">
								<FileUploader
									roleType={userType}
									defaultFileList={plannedMaintenanceTemplate.attachments || []}
									uploaderType={'readOnly'}
								/>
							</Card>
						</div>
					) : null}
					<PMTemplateTasksDisplay plannedMaintenanceTemplate={plannedMaintenanceTemplate} />
					{nullSafeGet('supplierContractDocuments.0', plannedMaintenanceTemplate) ? (
						<div className="mt-2">
							<Card title="Contract Documents">
								<FileUploader
									roleType={userType}
									defaultFileList={plannedMaintenanceTemplate.supplierContractDocuments || []}
									uploaderType={'readOnly'}
								/>
							</Card>
						</div>
					) : null}
				</div>
			</Col>
		</Row>
	);
};

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(PMTemplateDetailCard);
